
import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatCheckbox } from '@angular/material/checkbox';
import { DateAdapter, NativeDateAdapter } from '@angular/material/core';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule, MatHint, MatLabel } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio';
import { AntragsType } from '@ebeihilfe/core';
import { NumberInputComponent } from '@ebeihilfe/web-shared/number-input';
import { TextInputComponent } from '@ebeihilfe/web-shared/text-input';
import { TranslateModule } from '@ngx-translate/core';

import { BaseDynamicFormElementInterface } from '../../../model';
@Component({
  selector: 'form-base-element',
  templateUrl: './dynamic-form-element.component.html',
  imports: [
    ReactiveFormsModule,
    MatRadioGroup,
    MatRadioButton,
    MatCheckbox,
    MatHint,
    MatDatepickerModule,
    MatInputModule,
    MatFormFieldModule,
    MatLabel,
    TextInputComponent,
    NumberInputComponent,
    TranslateModule
],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DynamicFormElementComponent {
  private readonly dateAdapter: NativeDateAdapter = inject(DateAdapter) as NativeDateAdapter;

  @Input() public form!: FormGroup;
  @Input() public formElement!: BaseDynamicFormElementInterface<string>;
  @Input() public model!: Record<string, unknown>;

  public get isHidden(): boolean {
    const isHidden = this.formElement.hide?.(this.model as unknown as { antragsArt: AntragsType }) ?? false;
    if (isHidden) {
      this.form.get(this.formElement.key)?.setValue(null);
    }
    return isHidden;
  }

  public onDateChange(event: MatDatepickerInputEvent<Date>, key: string): void {
    const date = event.value;
    if (date) {
      const formattedDate = this.dateAdapter.toIso8601(date);
      if (formattedDate) {
        this.form.get(key)?.setValue(formattedDate, { emitEvent: false });
      }
    }
  }
}
